export const environment = {
  production: false,
  url: "https://uat-generali-api-motor.policystreet.app",
  crmUrl: "https://uat-generali-api-crm.policystreet.app",
  signalrHubUrl: "https://uat-generali-api-crm.policystreet.app/hub",
  googleTagId: "",
  cleverTapId: "TEST-ZK9-6ZK-696Z",
};
